module.exports = __webpack_public_path__ + "assets/render.421cae7e.svg";